import { Header } from '../aglsl/Header';
var Description = /** @class */ (function () {
    function Description() {
        var _a, _b;
        this.regread = (_a = {},
            _a[0 /* ATTR */] = [],
            _a[1 /* CONST */] = [],
            _a[4 /* VAR */] = [],
            _a[2 /* TEMP */] = [],
            _a[3 /* OUT */] = [],
            _a[5 /* SAMPLER */] = [],
            _a[15 /* NATIVE */] = [],
            _a);
        this.regwrite = (_b = {},
            _b[0 /* ATTR */] = [],
            _b[1 /* CONST */] = [],
            _b[4 /* VAR */] = [],
            _b[2 /* TEMP */] = [],
            _b[3 /* OUT */] = [],
            _b[5 /* SAMPLER */] = [],
            _b[15 /* NATIVE */] = [],
            _b);
        this.hasindirect = false;
        this.writedepth = false;
        this.hasmatrix = false;
        this.samplers = [];
        this.constants = 0;
        // added due to dynamic assignment 3*0xFFFFFFuuuu
        this.tokens = [];
        this.header = new Header();
        // native instructions per register
        this.native = {};
    }
    return Description;
}());
export { Description };
